import { combineDataProviders } from 'react-admin';

import { DashboardResources } from '@src/types';
import { usersDataProvider } from '@src/users';
import { userRolesDataProvider } from '@src/userRoles';
import { conditionsDataProvider } from '@src/conditions';
import { facetsDataProvider } from '@src/facets';
import {
  pricingRulesDataProvider,
  conditionDiscountsDataProvider,
  itemAdjustedPricesDataProvider,
} from '@src/resalePricing';
import { settingsDataProvider } from '@src/settings';

import {
  catalogItemsDataProvider,
  variantSkusDataProvider,
  pluginsDataProvider,
  repairsDataProvider,
} from './resources';

export const dataProvider = combineDataProviders((resource: DashboardResources | string) => {
  switch (resource) {
    case DashboardResources.CatalogItems:
      return catalogItemsDataProvider;
    case DashboardResources.VariantSkus:
      return variantSkusDataProvider;
    case DashboardResources.RecyclePlugins:
      return pluginsDataProvider;
    case DashboardResources.RepairPlugins:
      return pluginsDataProvider;
    case DashboardResources.ResalePlugins:
      return pluginsDataProvider;
    case DashboardResources.TradeinPlugins:
      return pluginsDataProvider;
    case DashboardResources.Repairs:
      return repairsDataProvider;
    case DashboardResources.CatalogFieldsMappingUpload:
      throw new Error('CatalogFieldsMappingUpload does not use a data provider');
    case 'users':
      return usersDataProvider;
    case 'userRoles':
      return userRolesDataProvider;
    case 'conditions':
      return conditionsDataProvider;
    case 'facets':
      return facetsDataProvider;
    case DashboardResources.PricingRules:
      return pricingRulesDataProvider;
    case DashboardResources.ConditionDiscounts:
      return conditionDiscountsDataProvider;
    case DashboardResources.ItemAdjustedPrices:
      return itemAdjustedPricesDataProvider;
    case 'settings':
      return settingsDataProvider;
    default:
      throw new Error(`Unknown resource: ${resource}`);
  }
});

export default dataProvider;
